import React from 'react';
import Image from 'components/Image';
import Props from './Props';

export default function LodgingsComponent({
  image,
  owner,
  description,
  name,
}: Props) {
  return (
    <div>
      <div className="pic js-tt">
        <Image
          borderContainerClassName="possessions-lodgings__border"
          className="possessions-lodgings__image"
          icon={image}
          alt={`${owner}'s lodgings`}
          type="lodgings"
          tooltipData={{ description, name }}
          border
        />
      </div>
      <h3 className="heading heading--3"><strong>Your Lodgings</strong></h3>
    </div>

  );
}
